import React from 'react';
import { alpha, Box, Collapse, List } from '@mui/material';
import { useLocation } from 'react-router-dom';

import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { CustomNavLink } from './CustomNavLink';
import type { NavLinkMapping } from './NavContent';

interface Props {
  groupName: string;
  isOpen: boolean;
  links: NavLinkMapping[];
  nestLevel?: number;
  onClick?: () => void;
  onCloseDrawer?: () => void;
}

export const CustomNavGroup = ({
  groupName,
  onClick,
  onCloseDrawer,
  isOpen,
  links,
  nestLevel = 0,
}: Props): JSX.Element => {
  const location = useLocation();

  const isSelected = !!links.find((link) => link.path === location.pathname);

  return (
    <Box sx={{ backgroundColor: isSelected ? alpha('#fff', 0.08) : 'transparent' }}>
      <CustomNavLink
        label={groupName}
        onClick={onClick}
        endIcon={isOpen ? <ExpandLess /> : <ExpandMore />}
      />
      <Collapse in={isOpen} timeout="auto">
        <List>
          {links.map((navItem) => (
            <CustomNavLink
              label={navItem.label}
              path={navItem.path}
              key={navItem.label}
              onClick={onCloseDrawer}
              selected={location.pathname === navItem.path}
              sx={{ pl: 2 * nestLevel }}
            />
          ))}
        </List>
      </Collapse>
    </Box>
  );
};
